export const normalizePuntoVentaText = value =>
  `${value || ""}`
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

// Extrae el prefijo de línea del producto: todo hasta el primer separador "-".
// El "+" (si existe) queda pegado al nombre base (p. ej. "MOTORARG +-" ->
// "motorarg+"), de modo que MOTORARG y MOTORARG+ sean prefijos distintos.
export const getProductLinePrefix = nombre => {
  const normalized = normalizePuntoVentaText(nombre);
  const beforeDash = normalized.split("-")[0] || "";
  return beforeDash.replace(/\s+/g, "");
};

export const getConfiguredPuntosDeVenta = value => {
  if (!Array.isArray(value)) return [];

  return value.map(item => `${item || ""}`.trim()).filter(Boolean);
};

export const getPuntosDeVentaOptions = puntosDeVenta =>
  getConfiguredPuntosDeVenta(puntosDeVenta).map(puntoVenta => ({
    label: puntoVenta,
    value: puntoVenta
  }));

export const getPuntoVentaAutocompleteValue = (options, puntoVenta) =>
  options.find(option => option.value === puntoVenta) || null;

export const isValidConfiguredPuntoVenta = (options, puntoVenta) => {
  const normalizedPuntoVenta = normalizePuntoVentaText(puntoVenta);

  if (!normalizedPuntoVenta) return false;

  return options.some(
    option => normalizePuntoVentaText(option.value) === normalizedPuntoVenta
  );
};

export const isProductCompatibleWithPuntoVenta = (product, puntoVenta) => {
  const normalizedPuntoVenta = normalizePuntoVentaText(puntoVenta).replace(
    /\s+/g,
    ""
  );

  if (!normalizedPuntoVenta) return true;

  // Match por IGUALDAD entre el punto de venta y el prefijo de línea del
  // producto. A diferencia del antiguo match por subcadena (.includes()),
  // esto impide que "MOTORARG" arrastre a los productos de "MOTORARG+",
  // porque "motorarg+" no es igual a "motorarg" (el "+" forma parte del
  // prefijo). Ref: SUP-000607.
  const searchableValues = [
    product && product.nombre,
    product && product.label
  ];

  return searchableValues.some(value => {
    if (!value) return false;
    return getProductLinePrefix(value) === normalizedPuntoVenta;
  });
};

export const filterProductsByPuntoVenta = (products, puntoVenta) => {
  if (!puntoVenta) return products;

  return products.filter(product =>
    isProductCompatibleWithPuntoVenta(product, puntoVenta)
  );
};

export const hasProductsIncompatibleWithPuntoVenta = (products, puntoVenta) =>
  filterProductsByPuntoVenta(products, puntoVenta).length !== products.length;
